<template>
  <div>
    <div class="flex w-full items-center fixed-top justify-between flex-wrap py-2 px-4">
      <div class="flex items-center flex-shrink-0 text-black mr-6">
        <router-link to="/">
          <img class="h-6" src="@/assets/images/homeface-logo.png" alt="Site Logo" />
        </router-link>
      </div>
      <div class="flex relative mr-6 my-2">
        <form class="flex" @submit.prevent="searchProduct">
          <input
            type="search"
            class="outline-none border border-gray-400 focus:border-teal-400 p-2 search-width-1400"
            placeholder="Suche..."
            v-model="search"
            @keyup.enter="searchProduct"
          />
          <button type="submit">
            <img
              class="outline-none bg-teal-400 px-3 py-3"
              src="../../../assets/images/search.svg"
              alt="Search Icon"
            />
          </button>
        </form>
      </div>
      <div class="relative flex float-right flex-shrink-0 text-black">
        <wishlist></wishlist>
        <userdropdown></userdropdown>
        <shoppingcarddropdown></shoppingcarddropdown>
      </div>
    </div>

    <nav role="navigation" class="w-full">
      <div class="lg:w-full lg:mx-auto lg:flex lg:flex-wrap items-center md:flex-no-wrap px-4">
        <div class="w-full md:w-auto md:flex-grow md:flex md:items-center">
          <ul
            class="flex flex-col pt-4 md:flex-row md:items-center md:mx-0 md:mt-0 md:pt-0 md:border-0"
          >
            <li v-for="category in allCategories" :key="category.id">
              <router-link
                :to="{
                  name: 'products',
                  query: { category: category.slug }
                }"
                class="pr-12 font-medium uppercase hover:text-teal-400"
                v-if="category.parent_id == null"
                :class="category.name_de == 'Sale' ? 'text-red-600' : ''"
              >{{ category.name_de }}</router-link>
            </li>
            <li class="pr-12 font-medium uppercase hover:text-teal-400">
              <router-link
                :to="{
                  name: 'shops',
                }"
                class="pr-12 font-medium uppercase hover:text-teal-400"
              >SHOPS</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import wishlist from "./Wishlist";
import userdropdown from "./UserDropdown";
import shoppingcarddropdown from "./ShoppingCardDropdown";

export default {
  components: { userdropdown, shoppingcarddropdown, wishlist },
  data() {
    return {
      // categories: [],
      // isOpen: false,
      search: "",
      slug: this.$route.params.slug,
    };
  },

  methods: {
    ...mapActions(["fetchCategories"]),
    searchProduct() {
      this.$router
        .push({ path: "/products", query: { q: this.search } })
        .catch(() => {});
    },
  },
  computed: {
    ...mapGetters(["allCategories"]),
  },
  created() {
    this.fetchCategories();
  },
};
</script>
<style>


@media (min-width: 1400px) and (max-width: 1920px) {
  .search-width-1400{
    width:560px;
  }
}


</style>